(function (app, ng) {

    app.controller("planningNotesController", planningNotesController);

    function planningNotesController(_, $q, $mdDialog, caseApi, caseModalService) {
        const $ctrl = this;

        const close = () => {
            $mdDialog.cancel();
        }

        const addNote = (content, caseId, user) => {
            const note = {
                Content: content,
                CreatedById: user.Id,
                CreatedBy: user,
                CreatedOn: new Date()
            }
            $ctrl.notes.push(note);

            caseApi.addPlanningNote(caseId, note).then(response => {
                note.NoteId = response.NoteId;
            });
        };

        const deleteNote = (noteId, caseId, $event) => {
            caseModalService.confirmNoteDeletion($event).then(() => {
                caseApi.deletePlanningNote(caseId, noteId);

                const noteIndex = $ctrl.notes.findIndex(note => note.NoteId === noteId);

                $ctrl.notes.splice(noteIndex, 1);
            });
        }

        ng.extend($ctrl,
            {
                close: close,
                addNote: addNote,
                deleteNote: deleteNote
            });
    }

}) (window.app, window.angular); //jshint: ignore:line